import React, { useState } from "react";

export default function AddForm() {
  const [form, setForm] = useState({
    name: "", // هيمثل اسم العميل = name
    email: "",
    password: "",
    brand: "", // هيمثل اسم البراند
  });
  const [avatar, setAvatar] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    setAvatar(file);
    const reader = new FileReader();
    reader.onload = () => setPreviewUrl(reader.result);
    reader.readAsDataURL(file);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    // تجهيز البيانات باستخدام FormData
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("password", form.password);
    formData.append("brand", form.brand);
    if (avatar) {
      formData.append("avatar", avatar);
    }

    try {
      const res = await fetch(
        "http://backend.goldensection.agency/public/api/user/register",
        {
          method: "POST",
          body: formData,
          credentials: "include", // عشان يتبعت معاه الكوكيز لو لزم
        },
      );

      if (!res.ok) throw new Error("فشل التسجيل");

      const data = await res.json();
      console.log("تم التسجيل بنجاح:", data);
      alert("✅ تم إنشاء الحساب بنجاح");
    } catch (error) {
      console.error(error);
      alert("❌ حصل خطأ أثناء إنشاء الحساب");
    }
  }

  return (
    <div className="form-container">
      <form className="form-box" onSubmit={handleSubmit}>
        <h2>إنشاء حساب البراند</h2>

        <label>
          اسم العميل
          <input
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            placeholder="مثال: محمد علي"
          />
        </label>
        <label>
          الايميل
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="example@goldenSection.com"
          />
        </label>

        <label>
          كلمة السر
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="••••••••"
          />
        </label>

        <label>
          اسم البراند
          <input
            name="brand"
            type="text"
            value={form.brand}
            onChange={handleChange}
            placeholder="مثال: Nile Cosmetics"
          />
        </label>

        <label>
          رفع صورة للبراند
          <input type="file" accept="image/*" onChange={handleImage} />
        </label>

        {previewUrl && (
          <div className="image-preview">
            <img src={previewUrl} alt="preview" />
          </div>
        )}

        <button type="submit">إنشاء الحساب</button>
      </form>
    </div>
  );
}
